/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsPaymentCreateInput } from "../../entities/models/PaymentCreateInput";
import { z } from "zod/v4";

export const modelsPaymentCreateInputSchema = z.object({
    "visit_group_id": z.string()
    }) as unknown as z.ZodType<ModelsPaymentCreateInput>